// components/ui/search-section.jsx
import React, { useState, useEffect } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const SearchSection = ({ onSearch }) => {
  console.log("--- SearchSection ---");
  const handleSearch = (e) => {
    onSearch(e.target.value);
  };

  return (
    <div className="px-4 py-4 max-w-xl mx-auto w-full">
      <div className="relative">
        <Input
          type="text"
          placeholder="Busca tu opción"
          className="w-full h-12 pl-4 pr-12 rounded-full bg-orange-100 border-none focus:ring-2 focus:ring-orange-500"
          onChange={handleSearch}
        />
        <Button className="absolute right-0 top-0 h-12 w-12 bg-orange-500 hover:bg-orange-600 rounded-r-full flex items-center justify-center">
          <Search className="h-5 w-5 text-white" />
        </Button>
      </div>
    </div>
  );
};

export default SearchSection;
